import addMilliseconds from 'date-fns/addMilliseconds'
import { store } from '../store'

export function serverTimeDate() {
  const result = addMilliseconds(new Date(), store.state.timeDiff)
  // result.setHours(result.getHours() + 9)
  return result
}
